import { useAssetManagementPortalStore } from 'apps/asset-management-portal/src/app/hooks/useAssetManagementPortalStore';

export const useAssetManagementDocumentStore = () => {
  const { assetManagementDocumentStore } = useAssetManagementPortalStore();
  return assetManagementDocumentStore;
}
